import { FilterDocument } from '@griply/types';
import { isShowingHabits, toggleHabitsInFilterDocument } from '@griply/utils';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Repeat } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenu,
  PopupMenuList,
  PopupMenuListItem,
  PopupMenuToggle,
} from 'shared/components/ui/popup-menu';

export type CompletedContextMenuProps = {
  referenceElement?: React.RefObject<HTMLButtonElement>;
  onClose: () => void;
  filterDocument: FilterDocument;
  setFilterDocument: React.Dispatch<React.SetStateAction<FilterDocument>>;
};

export const CompletedContextMenu: React.FC<CompletedContextMenuProps> = ({
  referenceElement,
  onClose,
  filterDocument,
  setFilterDocument,
}) => {
  const { t } = useTranslation();

  const showingHabits = isShowingHabits(filterDocument);

  const toggleShowHabits = () => {
    setFilterDocument(toggleHabitsInFilterDocument);
  };

  return (
    <PopupMenu
      referenceElement={referenceElement}
      position="bottom-end"
      onOutside={onClose}
    >
      <PopupMenuList hasBottomBorder>
        <PopupMenuListItem>
          <PopupMenuToggle
            start={<Icon icon={Repeat} />}
            label={t('pages.today.show-habits.label')} // Reuse today's label or find appropriate key
            onChange={toggleShowHabits}
            checked={showingHabits}
          />
        </PopupMenuListItem>
      </PopupMenuList>
    </PopupMenu>
  );
};
